<template>
  <span :class='classTitle' @click='openSubNav' h="browse-top-menu">
    <span>{{ list.title }}</span>
  </span>
</template>

<script>
import { computed } from 'vue'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

export default {
  name: 'TabsDT',
  props: ['list', 'classTitle'],
  setup(props) {
    const generalStore = useGeneralInfoStore()
    
    const menuItemSelected = computed(() => generalStore.generalData.megaMenuInfor.itemSelected)

    const openSubNav = () => {
      if(props.list.sub_nav) {
        generalStore.setTabIndex(0)
        if(!menuItemSelected.value || menuItemSelected.value.title !== props.list.title) {
          const data = {
            status: true,
            itemSelected: props.list
          }
          generalStore.setMegaMenuStatus(data)
        }
        else {
          const data = {
            status: false,
            itemSelected: {}
          }
          generalStore.setMegaMenuStatus(data)
        }
      }
    }
    return {
      openSubNav
    }
  }
}
</script>

<style scoped>

</style>
